import React from 'react';
import { Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { Typography } from '@material-ui/core';
// @ts-ignore
import Timestamp from 'react-timestamp';
import createStyles from '@material-ui/core/styles/createStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import HCLTreeMxGraph from '../../../../../mxGraph/HCLTreeMxGraph/HCLTreeMxGraph';

const styles = (theme: Theme) => createStyles({
  root: {
    backgroundColor: 'rgba(133,133,133,0.15)',
    borderTop: '1px solid #838796',
  },
  toolbar: {
    height: '24px',
    minHeight: '24px',
    justifyContent: 'space-between',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
  },
  spinnerContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  progress: {
    color: theme.palette.text.primary,
    marginRight: '0.4rem',
  },
});

interface Props extends WithStyles<typeof styles> {
  graph: HCLTreeMxGraph;
  dateModified: string;
  saving: boolean;
}

const StatusBar = (props: Props) => {
  const {
    classes, graph, dateModified, saving,
  } = props;
  const count = graph.getSelectionCount();
  const selectionStatus = count < 1 ? 'Nothing Selected' : `${count} cells selected`;

  const saveStatus = saving ? (
    <div className={classes.spinnerContainer}>
      <CircularProgress className={classes.progress} size={16} />
      <Typography variant="caption" color="textSecondary">Saving...</Typography>
    </div>
  ) : (
    <React.Fragment>
      Last Saved
      {' '}
      <Timestamp date={dateModified} relative autoUpdate />
    </React.Fragment>
  );

  return (
    <div className={classes.root}>
      <Toolbar className={classes.toolbar} variant="dense">
        <Typography variant="caption" color="textSecondary">
          {saveStatus}
        </Typography>
      </Toolbar>
    </div>
  );
};

export default withStyles(styles)(StatusBar);
